<template>
  <div>
    <slot v-bind="{ showDialog }">
      <v-btn
        @click="showDialog"
        dark
        x-small
        :color="color"
        :outline="type != 'qrcode' && type != 'advancedQrcode'"
        depressed
      >
        <div>
          <template v-if="type == 'transfer'">
            {{ $t('Premium Transfer') }}
          </template>
          <template v-else-if="type == 'paypal' || type == 'gbprime'">
            {{ $t('pay_by_credit_card') }}
          </template>
          <template v-else-if="type == 'advancedPaypal' || type == 'advancedGbprime'">
            {{ $t('pay_by_credit_card') }}
          </template>
          <template v-else-if="type == 'qrcode'">
            {{ $t('pay_by_qrcode') }}
          </template>
          <template v-else-if="type == 'advancedQrcode'">
            {{ $t('pay_by_qrcode') }}
          </template>
        </div>
      </v-btn>
    </slot>
    <v-dialog scrollable persistent v-if="dialog" v-model="dialog" max-width="550">
      <v-card style="height: 100%">
        <div class="text-xs-right">
          <v-spacer></v-spacer>
          <v-btn flat icon small fab @click="onClose">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <v-card-title style="padding-bottom: 0; padding-top: 0">
          <h2
            style="margin-top: 0"
            v-if="type === 'paypal' || type === 'qrcode' || type == 'gbprime'"
          >
            {{ $t('Registering or Extending Premium Package') }}
          </h2>
          <h2
            style="margin-top: 0"
            v-if="
              type === 'advancedPaypal' || type === 'advancedQrcode' || type == 'advancedGbprime'
            "
          >
            {{ $t('Registering or Extending Advanced Package') }}
          </h2>
        </v-card-title>
        <form v-show="!loading">
          <v-card-text
            style="padding-top: 10px"
            v-if="type == 'gbprime' || type == 'advancedGbprime'"
          >
            <h3 v-show="!isMember">{{ $t('contact_information') }}</h3>
            <v-layout wrap row v-if="!isMember">
              <v-flex xs12 sm6 class="pa-1">
                <label for>{{ $t('Phone') }}</label>
                <div class="form-control" :class="{ 'has-error': errors.has('Phone') }">
                  <input
                    type="text"
                    class="form-control"
                    name="Phone"
                    :data-vv-as="$t('Phone')"
                    :placeholder="$t('Phone')"
                    v-model="creditCard.phoneno"
                    v-validate="{ required: true, numeric: true }"
                    maxlength="250"
                  />

                  <span class="text-error" v-if="errors.has('Phone')">
                    {{ errors.first('Phone') }}
                  </span>
                </div>
              </v-flex>
              <v-flex xs12 sm6 class="pa-1">
                <label for>{{ $t('Email') }}</label>
                <div class="form-control" :class="{ 'has-error': errors.has('Email') }">
                  <input
                    type="text"
                    class="form-control"
                    name="Email"
                    :data-vv-as="$t('Email')"
                    :placeholder="$t('Email')"
                    v-model="creditCard.email"
                    v-validate="{ required: true, email: true }"
                    maxlength="250"
                  />

                  <span class="text-error" v-if="errors.has('Email')">
                    {{ errors.first('Email') }}
                  </span>
                </div>
              </v-flex>
            </v-layout>
            <v-divider v-show="!isMember" class="mt-3 mb-3"></v-divider>
            <h3>{{ $t('credit_card_payment_information') }}</h3>
            <v-layout wrap row>
              <v-flex xs12 class="pa-1">
                <label for>{{ $t('name_card') }}</label>
                <div class="form-control" :class="{ 'has-error': errors.has('name_card') }">
                  <input
                    type="text"
                    class="form-control"
                    :data-vv-as="$t('name_card')"
                    name="name_card"
                    :placeholder="$t('name_card')"
                    v-model="creditCard.name"
                    maxlength="255"
                    v-validate="{ required: true }"
                  />

                  <span class="text-error" v-if="errors.has('name_card')">
                    {{ errors.first('name_card') }}
                  </span>
                </div>
              </v-flex>
              <v-flex xs12 class="pa-1">
                <label for>{{ $t('number_card') }}</label>
                <div class="form-control" :class="{ 'has-error': errors.has('number_card') }">
                  <input
                    type="text"
                    class="form-control"
                    :data-vv-as="$t('number_card_error')"
                    name="number_card"
                    :placeholder="$t('number_card')"
                    v-model="creditCard.number"
                    maxlength="16"
                    v-validate="{ credit_card: true, required: true, regex: /[0-9]{16}$/ }"
                  />

                  <span class="text-error" v-if="errors.has('number_card')">
                    {{ errors.first('number_card') }}
                  </span>
                </div>
              </v-flex>

              <v-flex xs6 class="pa-1">
                <label for>{{ $t('expiration_month') }}</label>
                <div class="form-control" :class="{ 'has-error': errors.has('expiration_month') }">
                  <input
                    type="text"
                    class="form-control"
                    :data-vv-as="$t('expiration_month')"
                    name="expiration_month"
                    :placeholder="$t('expiration_month')"
                    v-model="creditCard.expiration_month"
                    maxlength="2"
                    v-validate="{ required: true, regex: /[0-9]{2}$/ }"
                  />

                  <span class="text-error" v-if="errors.has('expiration_month')">
                    {{ errors.first('expiration_month') }}
                  </span>
                </div>
              </v-flex>

              <v-flex xs6 class="pa-1">
                <label for>{{ $t('expiration_year') }}</label>
                <div class="form-control" :class="{ 'has-error': errors.has('expiration_year') }">
                  <input
                    type="text"
                    class="form-control"
                    :data-vv-as="$t('expiration_year')"
                    name="expiration_year"
                    :placeholder="$t('expiration_year')"
                    v-model="creditCard.expiration_year"
                    maxlength="2"
                    v-validate="{ required: true, regex: /[0-9]{2}$/ }"
                  />

                  <span class="text-error" v-if="errors.has('expiration_year')">
                    {{ errors.first('expiration_year') }}
                  </span>
                </div>
              </v-flex>

              <v-flex xs12 xs6 class="pa-1">
                <label for>{{ $t('CVV') }}</label>
                <div class="form-control" :class="{ 'has-error': errors.has('CVV') }">
                  <input
                    type="text"
                    class="form-control"
                    name="CVV"
                    :placeholder="$t('CVV')"
                    v-model="creditCard.security_code"
                    maxlength="3"
                    v-validate="{ required: true, regex: /[0-9]{3}$/ }"
                  />

                  <span class="text-error" v-if="errors.has('CVV')">
                    {{ errors.first('CVV') }}
                  </span>
                </div>
              </v-flex>

              <v-flex
                v-if="type == 'gbprime' || type == 'advancedGbprime'"
                xs12
                class="text-xs-center"
              >
                <v-btn @click="close" class="mx-0" color="grey" outline>{{ $t('cancel') }}</v-btn>
                <v-btn @click="gbPrimePay" class="mx-0" depressed color="primary">{{
                  $t('Proceed')
                }}</v-btn>
              </v-flex>

              <v-flex v-if="type == 'transfer'" xs12 class="text-xs-center">
                <v-btn @click="close" class="mx-0" color="grey" outline>{{ $t('cancel') }}</v-btn>
                <v-btn @click="saveData('transfer')" class="mx-0" depressed color="primary">{{
                  $t('Proceed')
                }}</v-btn>
              </v-flex>

              <v-flex
                v-show="type == 'paypal' || type == 'advancedPaypal'"
                xs12
                class="text-xs-center"
              >
                <div :ref="params" :id="params" style="margin-top: 15px"></div>
              </v-flex>

              <v-flex
                v-if="type == 'qrcode' || type == 'advancedQrcode'"
                xs12
                class="text-xs-center"
              >
                <v-btn @click="close" class="mx-0" color="grey" outline>{{ $t('cancel') }}</v-btn>
                <v-btn @click="gbprimeqrcode" class="mx-0" depressed color="primary">{{
                  $t('Proceed')
                }}</v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-text style="padding-top: 10px" v-else>
            <v-layout wrap row>
              <v-flex xs12 sm6 class="pa-1">
                <label for>{{ $t('Phone') }}</label>
                <div class="form-control" :class="{ 'has-error': errors.has('Phone') }">
                  <input
                    type="text"
                    class="form-control"
                    name="Phone"
                    :data-vv-as="$t('Phone')"
                    :placeholder="$t('Phone')"
                    v-model="input.phoneno"
                    v-validate="{ required: true, numeric: true }"
                  />

                  <span class="text-error" v-if="errors.has('Phone')">
                    {{ errors.first('Phone') }}
                  </span>
                </div>
              </v-flex>
              <v-flex xs12 sm6 class="pa-1">
                <label for>{{ $t('Email') }}</label>
                <div class="form-control" :class="{ 'has-error': errors.has('Email') }">
                  <input
                    type="text"
                    class="form-control"
                    name="Email"
                    :data-vv-as="$t('Email')"
                    :placeholder="$t('Email')"
                    v-model="input.email"
                    v-validate="{ required: true, email: true }"
                  />

                  <span class="text-error" v-if="errors.has('Email')">
                    {{ errors.first('Email') }}
                  </span>
                </div>
              </v-flex>

              <v-flex v-if="type == 'transfer'" xs12 class="text-xs-center">
                <v-btn @click="close" class="mx-0" color="grey" outline>{{ $t('cancel') }}</v-btn>
                <v-btn @click="saveData('transfer')" class="mx-0" depressed color="primary">{{
                  $t('Proceed')
                }}</v-btn>
              </v-flex>

              <v-flex
                v-show="type == 'paypal' || type == 'advancedPaypal'"
                xs12
                class="text-xs-center"
              >
                <div :ref="params" :id="params" style="margin-top: 15px"></div>
              </v-flex>

              <v-flex
                v-if="type == 'qrcode' || type == 'advancedQrcode'"
                xs12
                class="text-xs-center"
              >
                <v-btn @click="close" class="mx-0" color="grey" outline>{{ $t('cancel') }}</v-btn>
                <v-btn @click="gbprimeqrcode" class="mx-0" depressed color="primary">
                  {{ $t('Proceed') }}
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
        </form>
        <template v-if="loading">
          <div class="py-4">
            <v-container fill-height grid-list-md text-xs-center>
              <v-layout row wrap align-center>
                <v-flex>
                  <v-progress-circular
                    indeterminate
                    color="primary"
                    :width="3"
                    :size="45"
                  ></v-progress-circular>
                </v-flex>
              </v-layout>
            </v-container>
          </div>
        </template>
      </v-card>
    </v-dialog>
    <v-dialog scrollable v-model="showQrCode" max-width="376" persistent>
      <v-card>
        <div class="text-xs-right">
          <v-btn fab small flat @click="closeQrCode" :loading="loadingQr">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <div v-if="qrimage">
            <div class="text-xs-center">
              โปรดชำระเงินภายในเวลา
              <countdown :time="expriedTime * 1000" class="primary--text">
                <template slot-scope="props">
                  <template v-if="props.minutes > 0">
                    {{ props.minutes }}
                    <span class="small">{{ $t('Minutes') }}</span>
                  </template>
                  <template v-else>
                    {{ props.seconds }}
                    <span class="small">{{ $t('Seconds') }}</span>
                  </template>
                </template>
              </countdown>
            </div>
            <div class="text-xs-center mb-4">
              {{ $t('If you already have proceeded a payment, you may close this popup window.') }}
            </div>
            <img :src="qrimage" style="width: 100%" />
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <form
      v-show="false"
      ref="gbchargeform"
      name="form"
      :action="`https://api.gbprimepay.com/v1/tokens/3d_secured`"
      method="POST"
      enctype="application/x-www-form-urlencoded"
    >
      publicKey:

      <input type="text" name="publicKey" :value="'CSAQoqa1weFgT7p9IENwQpqj1KdM7Wxd'" />
      <br />
      gbpReferenceNo:
      <input type="text" name="gbpReferenceNo" :value="gbpReferenceNo" />
      <v-btn v-if="false" type="submit">send</v-btn>
    </form>
    <v-dialog v-model="dialogMemberCheck" width="500">
      <v-card>
        <form>
          <v-card-text>
            <v-btn
              flat
              icon
              small
              fab
              style="position: absolute; z-index: 7; right: 16px"
              @click="dialogMemberCheck = false"
            >
              <v-icon>close</v-icon>
            </v-btn>
            <v-img
              @click="openLinkAds(`https://zwiz.app/${currentLang}/register`)"
              src="/static/img/banner-package.jpg"
              style="border-radius: 10px; cursor: pointer"
            ></v-img>
            <v-card class="text-xs-center pa-3 mt-2">
              <template v-if="loading">
                <div class="py-4">
                  <v-container fill-height grid-list-md text-xs-center>
                    <v-layout row wrap align-center>
                      <v-flex>
                        <v-progress-circular
                          indeterminate
                          color="primary"
                          :width="3"
                          :size="45"
                        ></v-progress-circular>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </div>
              </template>
              <div v-else>
                <div
                  v-if="dialogMemberCheck"
                  class="form-control"
                  :class="{ 'has-error': errors.has('Email') }"
                >
                  <input
                    type="text"
                    class="form-control"
                    name="Email"
                    :data-vv-as="$t('member_email')"
                    :placeholder="$t('member_email')"
                    v-model="memberEmail"
                    v-validate="{ required: true, email: true }"
                  />

                  <span class="text-error" v-if="errors.has('Email')">
                    {{ errors.first('Email') }}
                  </span>
                </div>
                <v-btn
                  class="mt-4"
                  style="width: 50%; font-size: 16px"
                  dark
                  color="primary"
                  depressed
                  @click="onClickCheckEmail()"
                >
                  <template>
                    {{ $t('continue') }}
                  </template>
                </v-btn>
              </div>
            </v-card>

            <div class="text-xs-center mt-3">
              <div>
                <label style="font-size: 14px; font-weight: bold" for>{{
                  $t('dont_have_an_account')
                }}</label>
              </div>

              <v-btn
                :loading="loading"
                class="mt-3"
                style="font-size: 16px"
                dark
                color="primary"
                depressed
                outline
                @click="onClickContinueAsGuest()"
              >
                <template>
                  {{ $t('continue_as_guest') }}
                </template>
              </v-btn>
              <div class="mt-2">
                <a
                  :href="`https://zwiz.app/${currentLang}/register`"
                  target="_blank"
                  style="text-decoration: revert; color: #000"
                >
                  {{ $t('create_account') }}</a
                >
              </div>
            </div>
          </v-card-text>
        </form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import Multiselect from 'vue-multiselect'
import AutoresizeTextarea from '@/components/elements/AutoresizeTextarea.vue'
import { mapGetters } from 'vuex'
import config from '@/config'
import axios from 'axios'

export default {
  props: ['params', 'type', 'pack', 'pid', 'color'],
  data() {
    return {
      memberEmail: '',
      typePackage: 'advanced',
      dialogMemberCheck: false,
      dialog: false,
      loading: true,
      paypal_actions: undefined,
      gbpReferenceNo: '',
      creditCard: {
        name: '',
        number: '',
        expiration_month: '',
        expiration_year: '',
        security_code: '',
        phone: '',
        email: '',
      },
      input: {
        age: null,
        phoneno: '',
        province: '',
        email: '',
        business_type: '',
        suggest: '',
        reason_to_buy: '',
        suggest_other: '',
        locale: '',
        source: 'CMS',
        contact: '',
      },
      input_cache: '',
      options: {
        reason_to_buy: [
          'Real-time Response',
          'Line chatbot',
          'status & Tag',
          'Broadcast (Customize)',
          'Shop service (unlimited)',
          'Import previous users',
          'AI Training',
          'Line notification',
          'Reply to a comment (selected posts)',
          'Creating more than 10 sets of Q&A in Reply Comment',
          'Creating more than 10 sets of Q&A in Chabot Conversation',
        ],
        businesstype: [
          'Accessory',
          'Application & Platform',
          'Automotive',
          'Agriculture',
          'Accommodation',
          'Beauty',
          'Blogger',
          'Construction',
          'Dental Clinic',
          'Education',
          'Electronics',
          'Event',
          'Fashion',
          'Finance & Investment',
          'Food & Beverage',
          'Gadget & IT',
          'Game',
          'Gold',
          'Health',
          'Insurance',
          'Lifestyle',
          'Logistics',
          'Media & Entertainment',
          'Medication',
          'Mom and Kids',
          'Online Marketing',
          'Property',
          'Packaging',
          'Restaurant',
          'Travel',
          'Others',
        ],
        suggest: ['Facebook', 'Google', 'Other'],
      },
      qrimage: null,
      showQrCode: false,
      loadingQr: false,
      refno: null,
      qrcodeInterval: null,
      counter: 0,
      expriedTime: 900,
      isMember: false,
    }
  },
  components: {
    Multiselect,
    AutoresizeTextarea,
  },
  async mounted() {
    var vm = this
    this.input_cache = JSON.stringify(this.input)
    if (this.type == 'paypal' || this.type == 'advancedPaypal') {
      await vm.$nextTick(function () {
        let itemname = vm.params.split('_')
        vm.renderPaypalBtn(
          `#${vm.params}`,
          itemname[0] === 'advanced'
            ? itemname[2] === 'extra'
              ? '12month_extra_advanced_fb'
              : `${itemname[1]}_${itemname[0]}_${itemname[2]}`
            : itemname[0] === 'test'
            ? 'test_1month_advanced_fb'
            : itemname[1] + '_' + itemname[2] + (itemname[3] ? '_' + itemname[3] : '')
        )
      })
    }

    // await this.getAdminPageInfo()
  },
  computed: {
    formErrors() {
      return this.errors.items
    },
    ...mapGetters({
      selectedBot: 'selectedBot',
      botlist: 'botlist',
      currentLang: 'currentLang',
    }),
  },
  methods: {
    openLinkAds(url) {
      window.open(url, '_blank')
    },
    async onClickCheckEmail() {
      const vm = this
      let result = await vm.$validator.validateAll()
      if (!result) {
      } else {
        vm.loading = true
        let url = `${config.serverUrlSso}api/member/find-seq-zwiz-no-by-email?email=${vm.memberEmail}`
        try {
          const response = await axios.get(url)
          if (response.data.result.seq_zwiz_no) {
            if (vm.type == 'qrcode' || vm.type == 'advancedQrcode') {
              this.input.phoneno = response.data.result.telephone_no
              this.input.email = vm.memberEmail
              vm.gbprimeqrcode()
            } else if (vm.type == 'gbprime' || vm.type == 'advancedGbprime') {
              this.creditCard.email = vm.memberEmail
              this.creditCard.phoneno = response.data.result.telephone_no
              this.dialog = true
              this.isMember = true
            }
            vm.loading = false
          }
        } catch (error) {
          vm.loading = false
          vm.$swal.fire({
            title: vm.$t('Error'),
            text:
              error.response.data.message === 'account_not_found'
                ? vm.$t('account_not_registered')
                : error.response.data.message,
            type: 'error',
            confirmButtonText: vm.$t('Confirm'),
            cancelButtonText: vm.$t('cancel'),
            reverseButtons: true,
            footer: vm.$t('if_you_want_any_help_text'),
          })
        }
      }
    },
    onClickContinueAsGuest() {
      const vm = this
      this.isMember = false
      vm.dialog = true
      vm.dialogMemberCheck = false
    },
    async gbPrimePay() {
      var result = await this.$validator.validateAll()
      if (result) {
        this.loading = true
        var data = {
          pageid: this.selectedBot.pageid,
          body: this.creditCard,
        }

        const isSuccess = await this.saveAdminPageInfo()
        if (!isSuccess) return

        var response = await api.createCartToken(data)
        if (response.success) {
          var dataPackage = {
            pageid: this.selectedBot.pageid,
            body: {
              event_type: 'upgrade_page_package',
              itemname: this.checkPackage(),
              token: response.result.card.token,
              response_url: `https://cms.zwiz.ai/th/home?gbRef=${response.result.card.token}`,
              customer_email: this.creditCard.email,
              customer_phoneno: this.creditCard.phoneno,
            },
          }
          var responsePayment = await api.createCharge(dataPackage)
        } else {
          this.loading = false
          this.$swal.fire({
            title: this.$t('something_went_wrong'),
            type: 'warning',
            confirmButtonText: this.$t('Confirm'),
            reverseButtons: true,
          })
        }
        if (responsePayment.success) {
          this.gbpReferenceNo = responsePayment.result.gbpReferenceNo
          this.$nextTick(() => {
            this.$refs.gbchargeform.submit()
          })
        } else {
          this.loading = false
          this.$swal.fire({
            title: this.$t('something_went_wrong'),
            type: 'warning',
            confirmButtonText: this.$t('Confirm'),
            reverseButtons: true,
          })
        }
      }
    },
    showDialog() {
      // this.dialog = true
      this.dialogMemberCheck = true
      this.loading = false
    },
    async closeQrCode() {
      this.loadingQr = true
      await this.$store.dispatch('updateBotDetail')
      this.loadingQr = false
      this.showQrCode = false
      if (this.qrcodeInterval) {
        clearInterval(this.qrcodeInterval)
      }
      this.dialog = false
      location.reload()
    },
    pad(n, width, z) {
      z = z || '0'
      n = n + ''
      return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n
    },

    checkPackage() {
      if (this.pid) {
        var itemname = null
        switch (this.pid) {
          case '0':
            itemname = 'test_1month_advanced_fb'
            break
          case '8521':
            itemname = '3month_fb'
            break
          case '8520':
            itemname = '6month_fb'
            break
          case '8519':
            itemname = '12month_fb'
            break
          case '12233':
            itemname = '12month_extra_fb'
            break
          case '181011':
            itemname = '3month_advanced_fb'
            break
          case '181013':
            itemname = '6month_advanced_fb'
            break
          case '181014':
            itemname = '12month_advanced_fb'
            break
          case '181015':
            itemname = '12month_extra_advanced_fb'
            break
        }
        return itemname
      }
    },
    async gbprimeqrcode() {
      var result = await this.$validator.validateAll()
      if (!result) {
        // do stuff if not valid.
        this.goToErrorInput()
        return false
      }
      // this.refno =
      //   'GBQR' + this.pad(Math.floor(Math.random() * 9999), 4, '0') + dayjs().format('x')
      this.refno = (Date.now() + this.pad(Math.floor(Math.random() * 99), 4, '0')).substring(0, 15)

      var itemname = this.checkPackage()

      // itemname = 'test_zwiz'
      if (itemname == null) return false
      this.loading = true
      
      const isSuccess = await this.saveAdminPageInfo()
      if (!isSuccess) return

      var data = {
        itemname: itemname,
        ref: '',
        first_name: this.$store.state.facebook_name,
        last_name: '',
        phoneno: this.input.phoneno,
        email: this.input.email,
        contact: this.input.contact,
        pagename: this.selectedBot.pagename,
        pageurl: '',
        tax_invoice_status: false,
        taxpayer_id: '',
        taxpayer_name: '',
        taxpayer_address: '',
        taxpayer_postcode: '',
        taxpayer_province: '',
        taxpayer_district: '',
        taxpayer_subdistrict: '',
        age: this.input.age,
        province: this.input.province,
        businesstype: this.input.business_type,
        suggest: this.input.suggest_other,
        reason_to_buy: this.input.reason_to_buy,
        locale: this.$store.state.currentLang,
        source: this.input.source,
        type: this.type,
        package: this.pack,
        pageid: this.selectedBot.pageid,
        refno: this.refno,
      }
      
      var response = await this.gbcreaterefnofromupgradepremiumcms(data)
      if (response.status == 200) {
        let photo = response.data.result.qr_data.data.qrImage
        let binary = photo
        try {
          this.qrimage = 'data:image/jpeg;base64,' + binary
          this.dialog = false
          this.showQrCode = true
          this.checkQrCodeStatus(response.data.result.ref_code)
        } catch (error) {
          console.log(error)
        }
      } else {
        throw 400
      }
    },

    requestQrCode2(photo) {
      // var vm = this;
      return new Promise((resolve, reject) => {
        if (photo) {
          // var photobyte = vm.getByte(photo);
          resolve(new Uint8Array(photo))
        } else {
          reject()
        }
      })
    },
    gbcreaterefnofromupgradepremiumcms(data) {
      var request = {
        params: {},
        body: data,
      }
      return new Promise((resolve, reject) => {
        api.gbcreaterefnofromupgradepremiumcms(request, (error, response) => {
          if (error) reject(error)
          resolve(response)
        })
      })
    },
    onClose() {
      this.dialog = false
    },
    renderPaypalBtn: function (btn_name, itemname) {
      var SERVER = config.serverUrl
      var vm = this
      // console.log(btn_name, $(btn_name), vm.$refs[btn_name])
      // console.log(vm.$refs[btn_name])
      // var locale = this.currentLang == 'th' ? 'th_TH' : 'en_US'
      var locale = this.currentLang == 'th' ? 'th_TH' : 'gb' ? 'en_US' : 'la_LA'
      if ($(btn_name).get(0)) {
        this.$loadScript('https://www.paypalobjects.com/api/checkout.js')
          .then(() => {
            // Script is loaded, do something
            paypal.Button.render(
              {
                locale: locale,
                env: vm.environment, // Or 'production'
                // Set up the payment:
                // 1. Add a payment callback
                payment: function (data, actions) {
                  // 2. Make a request to your server
                  return actions.request
                    .post(SERVER + 'my-api/create-payment/', {
                      itemname: itemname,
                      pageid: vm.selectedBot.pageid,
                    })
                    .then(function (res) {
                      // 3. Return res.id from the response
                      return res.id
                    })
                },
                // Execute the payment:
                // 1. Add an onAuthorize callback
                onAuthorize: function (data, actions) {
                  // 2. Make a request to your server
                  return actions.request
                    .post(SERVER + 'my-api/execute-payment/', {
                      paymentID: data.paymentID,
                      payerID: data.payerID,
                      itemname: itemname,
                      pageid: vm.selectedBot.pageid,
                    })
                    .then(function (res) {
                      // 3. Show the buyer a confirmation message.
                      // alert("payment completed");

                      // console.log(res)
                      vm.$store.dispatch('loading')
                      if (res.status == 'success') {
                        if (vm.selectedBot) {
                          vm.$store.dispatch('updateBotDetail').then(
                            function () {
                              vm.$store.dispatch('loading')
                              vm.$swal
                                .fire({
                                  title: vm.$t('payment_successful'),
                                  type: 'success',
                                  confirmButtonText: vm.$t('Confirm'),
                                  cancelButtonText: vm.$t('cancel'),
                                  reverseButtons: true,
                                  footer: vm.$t('if_you_want_any_help_text'),
                                })
                                .then((result) => {
                                  vm.$swal.fire({
                                    title: vm.$t('Please wait,we will get back to you shortly'),
                                    type: 'info',
                                    confirmButtonText: vm.$t('Confirm'),
                                    showCancelButton: false,
                                    reverseButtons: true,
                                    footer: vm.$t('if_you_want_any_help_text'),
                                  })
                                })
                            },
                            function (error) {
                              vm.$store.dispatch('loading')
                              vm.errorMessage = vm.$t(
                                'Cannot update a chatbot. please contact us via Email:'
                              )
                              vm.$swal.fire({
                                title: vm.$t('payment_unsuccessful'),
                                text: vm.errorMessage,
                                type: 'error',
                                confirmButtonText: vm.$t('Confirm'),
                                cancelButtonText: vm.$t('cancel'),
                                reverseButtons: true,
                                footer: vm.$t('if_you_want_any_help_text'),
                              })
                            }
                          )
                        }
                        // vm.saveData('paypal')
                        // vm.close()
                      } else {
                        vm.errorMessage = res.status
                        vm.$swal.fire({
                          title: vm.$t('payment_unsuccessful'),
                          text: vm.errorMessage,
                          type: 'error',
                          confirmButtonText: vm.$t('Confirm'),
                          cancelButtonText: vm.$t('cancel'),
                          reverseButtons: true,
                          footer: vm.$t('if_you_want_any_help_text'),
                        })
                        // vm.saveData('paypal')
                        // vm.close()
                      }
                    })
                },
                validate: function (actions) {
                  vm.paypal_actions = actions
                  vm.paypal_actions.disable()
                },
                onClick: function (data, actions) {
                  if (vm.paypal_actions) {
                    vm.$validator.validate().then((result) => {
                      if (!result) {
                        // do stuff if not valid.
                        vm.paypal_actions.disable()
                        return false
                      }
                      vm.saveData('paypal')
                      vm.paypal_actions.enable()
                    })
                  }
                },
              },
              btn_name
            )
          })
          .catch(() => {
            // Failed to fetch script
          })
      }
    },
    close() {
      this.input = JSON.parse(this.input_cache)
      this.dialog = false
    },
    saveData() {
      let vm = this
      let openMsg
      var options = [
        [{ pid: 8521, qty: 1, option: '3 MONTHS' }],
        [{ pid: 8520, qty: 1, option: '6 MONTHS' }],
        [{ pid: 8519, qty: 1, option: '1 YEAR' }],
        [{ pid: 12233, qty: 1, option: '1 YEAR + SERVICE' }],
      ]
      openMsg = () => {
        window.location.assign(
          `https://m.me/361231620965547?ref=tempcart_${JSON.stringify(
            options.find((el) => el[0].pid == vm.pid)
          )}`
        )
      }

      vm.$validator.validateAll().then((result) => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        }
        vm.loading = true

        try {
          vm.sendData().then((response) => {
            vm.loading = false
            if (vm.type == 'transfer') {
              vm.close()
              openMsg()
            }
          })
        } catch (error) {
          vm.loading = false
        }
      })
    },
    sendData() {
      var vm = this
      return new Promise((resolve, reject) => {
        vm.input.locale = vm.$store.state.currentLang
        vm.input.type = vm.type
        vm.input.facebook_name = vm.$store.state.facebook_name
        vm.input.pagename = vm.selectedBot.pagename
        let data = {
          pageid: vm.$store.state.selectedBot.pageid,
          obj: vm.input,
          package: vm.pack,
        }
        // {
        //     locale: vm.input.locale,
        //     type: vm.input.type,
        //     facebook_name: vm.input.facebook_name,
        //     pagename: vm.input.pagename,
        //     phoneno: vm.input.phoneno,
        //     email: vm.input.email
        //   },
        

        api.postInfocustomerspremium(data, (error, response) => {
          if (error) reject(error)

          resolve(response)
        })
      })
    },
    checkQrCodeStatus(ref_code) {
      let vm = this
      vm.expriedTime = 900
      vm.counter = 0
      vm.qrcodeInterval = setInterval(async () => {
        let response = await vm.get(
          `scb/${vm.selectedBot.pageid}/inquiry-payment?ref_code=${ref_code}`
        )
        vm.counter++
        if (response.success && response.result.response_status == 'SUCCESS') {
          vm.loadingQr = true
          clearInterval(vm.qrcodeInterval)
          vm.$store.dispatch('updateBotDetail').then(() => {
            vm.loadingQr = false
            vm.showQrCode = false
            vm.dialog = false

            vm.$swal
              .fire({
                title: vm.$t('payment_successful'),
                text: vm.$t('setup_guide'),
                type: 'success',
                confirmButtonText: vm.$t('read_tutorial'),
                cancelButtonText: vm.$t('cancel'),
                reverseButtons: true,
                showCancelButton: true,
                footer: vm.$t('if_you_want_any_help_text'),
                html:
                  vm.pack === '1 Year Extra 7,999 Baht' || vm.pack === '1 Years Extra 11,999 Baht'
                    ? `<div>${vm.$t('qrLineNote')}</div><img src="/static/img/qr-line.png"></img>`
                    : '',
              })
              .then((result) => {
                if (result.value) {
                  window.open(
                    'https://blog.zwiz.app/',
                    '_blank',
                    'toolbar=yes,scrollbars=yes,resizable=yes,top=0,width=1000,height=900'
                  )
                }
                location.reload()
              })
          })
        } else if (vm.counter == 90) {
          vm.loadingQr = false
          vm.showQrCode = false
          vm.dialog = false
          vm.refno = null
          clearInterval(vm.qrcodeInterval)
          vm.$swal.fire({
            title: vm.$t('payment_unsuccessful'),
            text: 'โปรดชำระเงินในเวลาที่กำหนด',
            type: 'error',
            confirmButtonText: vm.$t('Confirm'),
            cancelButtonText: vm.$t('cancel'),
            reverseButtons: true,
            footer: vm.$t('if_you_want_any_help_text'),
          })
        }
      }, 10000)
    },
    async getAdminPageInfo() {
      api.getAdminPageInfo((error, response) => {
        if (error) {
          this.$swal({
            title: this.$t('Unsuccessful'),
            type: 'error',
            text: response.data && response.data.message ? response.data.message : '',
            confirmButtonText: this.$t('Confirm'),
          })
        } else if (response) {
          this.input.phoneno = response.phone_no || ''
          this.input.email = response.email || ''

          this.creditCard.phoneno = response.phone_no || ''
          this.creditCard.email = response.email || ''
        }
      })
    },
    async saveAdminPageInfo() {
      let payload = { phone_no: this.input.phoneno, email: '' }
      if (this.type === 'qrcode' || this.type === 'advancedQrcode') {
        payload.phone_no = this.input.phoneno
        payload.email = this.input.email
      } else {
        payload.phone_no = this.creditCard.phoneno
        payload.email = this.creditCard.email
      }

      return new Promise((resolve, reject) => {
        api.saveAdminPageInfo(payload, (error, response) => {
          if (error) {
            resolve(false)
          } else {
            resolve( true)
          }
        })
      }) 
    }
  },
  beforeDestroy() {
    if (this.qrcodeInterval) {
      clearInterval(this.qrcodeInterval)
    }
  },
  watch: {
    input: {
      deep: true,
      handler() {
        let vm = this
        if (vm.type == 'paypal' || vm.type == 'advancedPaypal') {
          vm.$validator.validate().then((result) => {
            if (!result) {
              // do stuff if not valid.
              vm.paypal_actions.disable()
              vm.errors.clear()
              return false
            }
            vm.paypal_actions.enable()
          })
        }
      },
    },
    dialog() {
      let vm = this
      if (vm.dialog == true) {
        // let data = { pageid: vm.$store.state.selectedBot.pageid, type: vm.type, package: vm.pack }
        vm.loading = true

        this.getAdminPageInfo()
        vm.loading = false


        // api.getInfocustomerspremium(data, (error, response) => {
        //   if (error) console.error(error)

        //   if (response.data.length) {
        //     Object.assign(vm.input, response.data[0])
        //   }
        //   vm.errors.clear()
        //   vm.loading = false
        // })
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/elements/premiumForm.vue